import {
  Home, Users, Building2, Contact2, Handshake, Package, GitBranch, CheckSquare,
  Send, TrendingUp, BookOpen, Megaphone, Target, Mail, FileText, LayoutTemplate,
  Route, Inbox, MessageSquare, Phone, Sparkles, Bot, Brain, Library, Workflow,
  Layers, ScrollText, BarChart3, PieChart, LineChart, DollarSign, Users2,
  HeartPulse, Rocket, RefreshCw, Plug, Shield, Settings, ShieldAlert,
} from "lucide-react";

export const NAV = [
  { label: null, items: [{ to: "/app", label: "Home", icon: Home, end: true }] },
  {
    label: "CRM", items: [
      { to: "/app/leads", label: "Leads", icon: Target },
      { to: "/app/contacts", label: "Contacts", icon: Users },
      { to: "/app/companies", label: "Companies", icon: Building2 },
      { to: "/app/deals", label: "Deals", icon: Handshake },
      { to: "/app/products", label: "Products", icon: Package },
    ],
  },
  {
    label: "Sales", items: [
      { to: "/app/pipeline", label: "Pipeline", icon: GitBranch },
      { to: "/app/tasks", label: "Tasks", icon: CheckSquare },
      { to: "/app/sequences", label: "Sequences", icon: Send },
      { to: "/app/forecast", label: "Forecast", icon: TrendingUp },
    ],
  },
  {
    label: "Marketing", items: [
      { to: "/app/campaigns", label: "Campaigns", icon: Megaphone },
      { to: "/app/audiences", label: "Audiences", icon: Users2 },
      { to: "/app/forms", label: "Forms", icon: FileText },
    ],
  },
  {
    label: "Conversations", items: [
      { to: "/app/inbox", label: "Inbox", icon: Inbox },
    ],
  },
  {
    label: "AI", items: [
      { to: "/app/growth", label: "Growth Engine", icon: Rocket },
      { to: "/app/copilot", label: "Aurelo Copilot", icon: Sparkles },
      { to: "/app/agents", label: "AI Agents", icon: Bot },
      { to: "/app/insights", label: "Intelligence", icon: Brain },
      { to: "/app/knowledge", label: "Knowledge", icon: Library },
    ],
  },
  {
    label: "Automations", items: [
      { to: "/app/workflows", label: "Workflows", icon: Workflow },
      { to: "/app/automation-logs", label: "Automation Logs", icon: ScrollText },
    ],
  },
  {
    label: "Analytics", items: [
      { to: "/app/analytics", label: "Dashboards", icon: BarChart3 },
      { to: "/app/revenue", label: "Revenue", icon: DollarSign },
    ],
  },
  {
    label: "Customers", items: [
      { to: "/app/customers", label: "Accounts", icon: HeartPulse },
      { to: "/app/renewals", label: "Renewals", icon: RefreshCw },
    ],
  },
  {
    label: "Workspace", items: [
      { to: "/app/integrations", label: "Integrations", icon: Plug },
      { to: "/app/admin", label: "Administration", icon: Shield },
      { to: "/app/settings", label: "Settings", icon: Settings },
    ],
  },
];

export const PLATFORM_GROUP = {
  label: "Platform",
  items: [{ to: "/app/platform-admin", label: "Platform Admin", icon: ShieldAlert }],
};
